
import request from '@/utils/request'

export function save(data) {
    return request({
        url: 'Worker/save',
        method: 'post',
        data
    })
}

export function getPageList(data) {
    return request({
        url: 'Worker/getPageList',
        method: 'post',
        data
    })
}

export function deleteObj(data) {
    return request({
        url: 'Worker/delete',
        method: 'post',
        data
    })
}
